/* Copyright 2019 Ellucian Company L.P. and its affiliates.
 * File: AddressStatus - Copy.ts */

export enum ChangePasswordResponse {
    success = 0,
    newPasswordValid = 1,
    nullValue = 2,
    minLength = 3,
    upperCase = 4,
    lowerCase = 5,
    digits = 6,
    symbols = 7,
    currentPasswordInvalid = 8
}